import { PRIVACY_EMAIL } from './privacyConstants';

/** Optional REACT_APP_TERMS_EMAIL; otherwise same inbox as privacy */
export const TERMS_CONTACT_EMAIL =
  process.env.REACT_APP_TERMS_EMAIL || PRIVACY_EMAIL;

export const TERMS_LAST_UPDATED = 'April 6, 2026';
